import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks';

import {
  AskingBidContainer,
  BlockStatus,
  ItemDetailsContainer,
  ItemNameContainer,
  ItemNumberContainer,
  MediaContainer,
  PublicCommentsContainer,
  SideNavContainer,
  TopBarContainer,
} from 'components/project/FloorBidderScreen';

import { Layout } from './Styles';

export const NPALayoutLarge = observer(({ attrFlowDirection }) => {
  const {
    AuctionStore: {
      auctionID,
      auctionLaneId,
      auctionLaneName,
      auctionList,
      connected,
      getAuctionAndLaneTitle,
      laneList,
      laneStatus,
    },
    UIStore: { handleJoinAuction, handleJoinLane },
  } = useStores();

  return (
    <>
      <Helmet>
        <title>Floor Tote (Large)</title>
      </Helmet>
      <Layout key={new Date()} laneStatus={laneStatus}>
        <TopBarContainer
          connected={connected}
          title={getAuctionAndLaneTitle}
          laneName={auctionLaneName}
          showLogo
          showLaunchPad
          showLogout={false}
        />
        <SideNavContainer
          auctionList={auctionList}
          currentAuctionId={auctionList && auctionID}
          laneList={laneList}
          currentLaneId={laneList && auctionLaneId}
          handleAuctionChange={(e) => handleJoinAuction(e.target.value)}
          handleLaneChange={(e) => handleJoinLane(e.target.value)}
        />
        <ItemNameContainer key={Math.random()} />
        <MediaContainer />
        <ItemNumberContainer />
        <AskingBidContainer />
        <BlockStatus />
        <PublicCommentsContainer />
        <ItemDetailsContainer flowDirection={attrFlowDirection} />
      </Layout>
    </>
  );
});


NPALayoutLarge.propTypes = {
  attrFlowDirection: PropTypes.string,
};

NPALayoutLarge.defaultProps = {
  attrFlowDirection: 'row',
};

export default NPALayoutLarge;
